import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "myCenter"
  }, [_c('Header'), _c('div', {
    staticClass: "usercont content"
  }, [_c('NavMenu'), _c('div', {
    ref: "menucont",
    staticClass: "menucont"
  }, [_c('div', {
    staticClass: "head-wrap"
  }, [_vm.infoList.headImgUrl ? _c('img', {
    attrs: {
      "src": _vm.infoList.headImgUrl
    }
  }) : _c('img', {
    attrs: {
      "src": require("@/assets/images/headimg.png")
    }
  }), _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.infoList.nickName))])])]), _c('div', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.infoList.phone))])]), _c('div', {
    staticClass: "my-grade"
  }, [_c('span', [_vm._v("Lv." + _vm._s(_vm.infoList.level || 0))]), _c('span', [_vm._v("我的等级")]), _c('span', {
    on: {
      "click": function click($event) {
        return _vm.$router.push('/grade');
      }
    }
  }, [_vm._v("去看看"), _c('i', {
    staticClass: "iconfont icongengduoxiangqing-copy"
  })])]), _c('div', {
    staticClass: "my-integral"
  }, [_c('span', [_vm._v(_vm._s(_vm.infoList.integral || 0))]), _c('span', [_vm._v("我的积分")]), _c('span', {
    on: {
      "click": function click($event) {
        return _vm.$router.push('/integral');
      }
    }
  }, [_vm._v("去看看"), _c('i', {
    staticClass: "iconfont icongengduoxiangqing-copy"
  })])]), _c('div', {
    staticClass: "my-coupon"
  }, [_c('span', [_vm._v(_vm._s(_vm.unableNum || 0))]), _c('span', [_vm._v("优惠券")]), _c('span', {
    on: {
      "click": function click($event) {
        return _vm.$router.push('/coupon');
      }
    }
  }, [_vm._v("去看看"), _c('i', {
    staticClass: "iconfont icongengduoxiangqing-copy"
  })])])])]), _c('div', {
    staticClass: "myOder"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("我的订单")]), _c('ul', [_c('li', {
    on: {
      "click": function click($event) {
        return _vm.goOrder(0);
      }
    }
  }, [_vm.ordernumber.init !== 0 ? _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.ordernumber.init))]) : _vm._e(), _vm._m(0), _c('div', {
    staticClass: "title"
  }, [_vm._v("待付款")])]), _c('li', {
    on: {
      "click": function click($event) {
        return _vm.goOrder(1);
      }
    }
  }, [_vm.ordernumber.unDeliver !== 0 ? _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.ordernumber.unDeliver))]) : _vm._e(), _vm._m(1), _c('div', {
    staticClass: "title"
  }, [_vm._v("待发货")])]), _c('li', {
    on: {
      "click": function click($event) {
        return _vm.goOrder(2);
      }
    }
  }, [_vm.ordernumber.delivered !== 0 ? _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.ordernumber.delivered))]) : _vm._e(), _vm._m(2), _c('div', {
    staticClass: "title"
  }, [_vm._v("已发货")])]), _c('li', {
    on: {
      "click": _vm.goExchange
    }
  }, [_vm._m(3), _c('div', {
    staticClass: "title"
  }, [_vm._v("退换/售后")])]), _c('li', {
    on: {
      "click": function click($event) {
        return _vm.goOrder(3);
      }
    }
  }, [_vm.ordernumber.received !== 0 ? _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.ordernumber.received))]) : _vm._e(), _vm._m(4), _c('div', {
    staticClass: "title"
  }, [_vm._v("待评价")])]), _c('li', {
    on: {
      "click": function click($event) {
        return _vm.goOrder(4);
      }
    }
  }, [_vm._m(5), _c('div', {
    staticClass: "title"
  }, [_vm._v("全部订单")])])])])])], 1), _c('Footer')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('i', {
    staticClass: "iconfont icondaifukuan"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('i', {
    staticClass: "iconfont icondaifahuo"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('i', {
    staticClass: "iconfont iconyifahuo"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('i', {
    staticClass: "iconfont iconhuanhuobeifen"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('i', {
    staticClass: "iconfont icondaipingjia"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('i', {
    staticClass: "iconfont iconbianzu"
  })]);
}];
export { render, staticRenderFns };